module.exports = __webpack_public_path__ + "img/kin.c0e7c013.svg";